import { createFileRoute, Outlet } from "@tanstack/react-router";
import { cn } from "cn";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";

export const Route = createFileRoute("/(member)/(public)/invite/$token")({
  component: InviteTokenLayout,
});

function InviteTokenLayout() {
  return (
    <PublicLayout>
      <ResponsiveWrapper
        className={cn(
          /* sorted */
          "grow",
          "py-12",
          "sm:mx-auto sm:w-full sm:max-w-3xl",
        )}
      >
        <Outlet />
      </ResponsiveWrapper>
    </PublicLayout>
  );
}
